module.exports = __webpack_public_path__ + "static/media/apple.6046f0c7.svg";